import * as yup from 'yup';
import dayjs from 'dayjs';
import { IBCFieldNames, cleanGuid } from './InternationalBreedingCertificateConstants';
import { TranslationKeys } from '../../../../constants/TranslationKeys';

export const getIBCSchema = (translate, termsList = [], isNotNewRequest = false) => {
    const shape = {
        [IBCFieldNames.SEMEN_COLLECTION_CERTIFICATE_ID]: yup
            .string()
            .nullable()
            .test(
                'is-valid-guid',
                translate(TranslationKeys.REQUIRED_FIELD, 'Required Field'),
                (val) => Boolean(cleanGuid(val))
            ),
        [IBCFieldNames.STALLION_ID]: yup.string().nullable(),

        [IBCFieldNames.MARE_NAME_EN]: yup
            .string()
            .trim()
            .required(translate(TranslationKeys.REQUIRED_FIELD, 'Required Field')),
        [IBCFieldNames.MARE_NAME_AR]: yup
            .string()
            .trim()
            .required(translate(TranslationKeys.REQUIRED_FIELD, 'Required Field')),
        [IBCFieldNames.MARE_SIRE_NAME_EN]: yup
            .string()
            .trim()
            .required(translate(TranslationKeys.REQUIRED_FIELD, 'Required Field')),
        [IBCFieldNames.MARE_SIRE_NAME_AR]: yup
            .string()
            .trim()
            .required(translate(TranslationKeys.REQUIRED_FIELD, 'Required Field')),
        [IBCFieldNames.MARE_DAM_NAME_EN]: yup
            .string()
            .trim()
            .required(translate(TranslationKeys.REQUIRED_FIELD, 'Required Field')),
        [IBCFieldNames.MARE_DAM_NAME_AR]: yup
            .string()
            .trim()
            .required(translate(TranslationKeys.REQUIRED_FIELD, 'Required Field')),
        [IBCFieldNames.RECORDED_MARE_OWNER_NAME_EN]: yup
            .string()
            .trim()
            .required(translate(TranslationKeys.REQUIRED_FIELD, 'Required Field')),
        [IBCFieldNames.RECORDED_MARE_OWNER_NAME_AR]: yup
            .string()
            .trim()
            .required(translate(TranslationKeys.REQUIRED_FIELD, 'Required Field')),
        [IBCFieldNames.RECORDED_MARE_OWNER_PHONE]: yup.string().trim().nullable(),
        [IBCFieldNames.MARE_BREEDER_NAME_EN]: yup
            .string()
            .trim()
            .required(translate(TranslationKeys.REQUIRED_FIELD, 'Required Field')),
        [IBCFieldNames.MARE_BREEDER_NAME_AR]: yup
            .string()
            .trim()
            .required(translate(TranslationKeys.REQUIRED_FIELD, 'Required Field')),
        [IBCFieldNames.MARE_HORSE_ADDRESS]: yup
            .string()
            .trim()
            .required(translate(TranslationKeys.REQUIRED_FIELD, 'Required Field')),
        [IBCFieldNames.MARE_REGISTRATION_NUMBER]: yup
            .string()
            .trim()
            .required(translate(TranslationKeys.REQUIRED_FIELD, 'Required Field')),
        [IBCFieldNames.MARE_UELN]: yup.string().trim().nullable(),
        [IBCFieldNames.COLOR_ID]: yup
            .string()
            .nullable()
            .test(
                'is-valid-guid',
                translate(TranslationKeys.REQUIRED_FIELD, 'Required Field'),
                (val) => Boolean(cleanGuid(val))
            ),
        [IBCFieldNames.MARE_ORIGIN_COUNTRY_ID]: yup
            .string()
            .nullable()
            .test(
                'is-valid-guid',
                translate(TranslationKeys.REQUIRED_FIELD, 'Required Field'),
                (val) => Boolean(cleanGuid(val))
            ),
        [IBCFieldNames.MARE_STUDBOOK_COUNTRY_ID]: yup
            .string()
            .nullable()
            .test(
                'is-valid-guid',
                translate(TranslationKeys.REQUIRED_FIELD, 'Required Field'),
                (val) => Boolean(cleanGuid(val))
            ),
        [IBCFieldNames.MARE_BIRTH_DATE]: yup
            .string()
            .nullable()
            .required(translate(TranslationKeys.REQUIRED_FIELD, 'Required Field'))
            .test(
                'max-today',
                translate(TranslationKeys.INVALID_DATE, 'Date must be today or earlier'),
                (val) => (!val ? true : dayjs(val).isBefore(dayjs().add(1, 'day'), 'day'))
            ),

        [IBCFieldNames.LAST_COVERING_DATE]: yup
            .string()
            .nullable()
            .required(translate(TranslationKeys.REQUIRED_FIELD, 'Required Field'))
            .test(
                'max-today',
                translate(TranslationKeys.INVALID_DATE, 'Date must be today or earlier'),
                (val) => (!val ? true : dayjs(val).isBefore(dayjs().add(1, 'day'), 'day'))
            )
            .test(
                'min-stallion-birth-date',
                translate(TranslationKeys.COVERING_DATE_AFTER_STALLION_BIRTH, 'Covering Date cannot be before Stallion Birth Date'),
                function (val) {
                    if (!val) return true;
                    const birth = this.parent[IBCFieldNames.STALLION_BIRTH_DATE_RAW];
                    if (!birth || !dayjs(birth).isValid()) return true;
                    return !dayjs(val).isBefore(dayjs(birth), 'day');
                }
            ),
        [IBCFieldNames.TRANSPORTED_STORED_SEMEN_CERT_SERIAL_NO]: yup.string().nullable(),
        [IBCFieldNames.OWNER_COMMENT]: yup.string().nullable(),
    };

    // Declaratively validate terms for new requests if terms are defined
    if (!isNotNewRequest && Array.isArray(termsList) && termsList.length > 0) {
        termsList.forEach((_, index) => {
            shape[`term_${index}`] = yup
                .boolean()
                .oneOf([true], translate(TranslationKeys.REQUIRED_FIELD, 'Required Field'));
        });
    }

    return yup.object().shape(shape);
};
